<script>
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let enabled = false;

  const dispatchToggled = () => {
    dispatch('toggled', { enabled: !enabled });
  };
</script>

<style style="text/scss" lang="scss">
  .checkbox-container {
    flex-shrink: 0;
    position: relative;
    display: inline-block;
    width: 60px;
    height: 32px;

    .togger-enabled {
      background-color: #a893f9 !important;
      border-color: #a893f9 !important;

      &:before {
        transform: translateX(24px) !important;
        background: white !important;
      }
    }

    .ui-toggler {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #fff;
      border: 2px solid #ececec;
      border-radius: 999px;
      transition: 0.4s;

      &:before {
        position: absolute;
        content: '';
        height: 24px;
        width: 24px;
        left: 4px;
        bottom: 2px;
        background-color: #ececec;
        border-radius: 50%;
        -webkit-transition: 0.4s;
        transition: 0.4s;
      }
    }
  }
</style>

<div class="checkbox-container">
  <span on:click={dispatchToggled} class="ui-toggler" class:togger-enabled={enabled} />
</div>
